import * as React from 'react';
import * as styles from './styles.css';
import { Spinner } from '@cian/ui-kit';

interface ITrendsSpinnerParams {
  isLoading: boolean;
}
export function TrendsSpinner({ isLoading }: ITrendsSpinnerParams) {
  return isLoading ? (
    <div data-testid="TrendsSpinnerId" className={styles['container']}>
      <div className={styles['spinner']}>
        <Spinner size={32} />
      </div>
    </div>
  ) : null;
}
